import React, { useState } from "react";
import { LuCopy, LuShare2 } from "react-icons/lu";
import { copyPaymentText, sharePixPayment } from "../services/paymentActionService";

export default function ModalPixCorrida({ chavePix, qrCodeUrl, valorCorrida, motoristaNome, onFechar }) {
  const [copiado, setCopiado] = useState(false);
  const [shareError, setShareError] = useState(false);

  const copiar = async () => {
    try {
      const copied = await copyPaymentText(chavePix);
      setCopiado(copied);
      if (copied) setTimeout(() => setCopiado(false), 3000);
    } catch (_) { setCopiado(false); }
  };

  const compartilhar = async () => {
    setShareError(false);
    try {
      const shared = await sharePixPayment({ pix: chavePix, amount: valorCorrida, driverName: motoristaNome });
      if (!shared) setShareError(true);
    } catch (error) {
      if (error?.message && !/cancel/i.test(error.message)) setShareError(true);
    }
  };

  return (
    <div style={{ position:"fixed",inset:0,zIndex:99990,background:"rgba(0,0,0,0.82)",display:"flex",alignItems:"flex-end",fontFamily:"'Segoe UI',system-ui,sans-serif" }}>
      <div style={{ width:"100%",maxWidth:480,maxHeight:"100dvh",overflowY:"auto",margin:"0 auto",background:"#0d1527",borderRadius:"24px 24px 0 0",padding:"24px 24px max(30px,calc(20px + env(safe-area-inset-bottom,0px)))",border:"1px solid rgba(6,182,212,0.25)",borderBottom:"none",animation:"zunoPaymentUp 0.3s ease" }}>
        <div style={{ width:36,height:4,background:"rgba(255,255,255,0.15)",borderRadius:2,margin:"0 auto 20px" }} />
        <div style={{ textAlign:"center",marginBottom:20 }}>
          <p style={{ color:"#06b6d4",fontWeight:800,fontSize:18,margin:"0 0 4px" }}>Pagar via Pix</p>
          <p style={{ color:"rgba(255,255,255,0.4)",fontSize:13,margin:0 }}>Pague para {motoristaNome?.split(" ")[0] || "o motorista"}</p>
        </div>

        {valorCorrida > 0 && (
          <div style={{ background:"rgba(6,182,212,0.07)",border:"1px solid rgba(6,182,212,0.15)",borderRadius:14,padding:12,textAlign:"center",marginBottom:16 }}>
            <p style={{ color:"rgba(255,255,255,0.35)",fontSize:10,letterSpacing:1,margin:"0 0 4px",textTransform:"uppercase" }}>Valor da corrida</p>
            <p style={{ color:"#06b6d4",fontSize:28,fontWeight:800,margin:0 }}>R$ {Number(valorCorrida).toFixed(2)}</p>
          </div>
        )}

        {qrCodeUrl ? (
          <div style={{ textAlign:"center",marginBottom:16 }}>
            <div style={{ background:"#fff",borderRadius:16,padding:16,display:"inline-block",boxShadow:"0 4px 24px rgba(0,0,0,0.4)" }}>
              <img src={qrCodeUrl} alt="QR Code Pix" style={{ width:190,height:190,display:"block" }} />
            </div>
            <p style={{ color:"rgba(255,255,255,0.3)",fontSize:11,marginTop:8 }}>Leia o QR Code pelo aplicativo do seu banco</p>
          </div>
        ) : (
          <div style={{ background:"rgba(255,255,255,0.03)",border:"1px dashed rgba(255,255,255,0.1)",borderRadius:14,padding:16,textAlign:"center",marginBottom:16 }}>
            <p style={{ color:"rgba(255,255,255,0.38)",fontSize:12,margin:0 }}>QR Code não fornecido pelo motorista. Use a chave Pix abaixo.</p>
          </div>
        )}

        {chavePix && (
          <div style={{ background:"rgba(6,182,212,0.06)",border:"1px solid rgba(6,182,212,0.2)",borderRadius:14,padding:"14px 16px",marginBottom:14 }}>
            <p style={{ color:"rgba(255,255,255,0.35)",fontSize:10,letterSpacing:1,margin:"0 0 8px",textTransform:"uppercase" }}>Chave ou código Pix</p>
            <p style={{ color:"#06b6d4",fontSize:13,fontWeight:700,margin:"0 0 12px",wordBreak:"break-all" }}>{chavePix}</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              <button type="button" onClick={copiar} style={{ padding:"10px 8px",borderRadius:10,border:`1px solid ${copiado?"rgba(34,197,94,0.4)":"rgba(6,182,212,0.4)"}`,background:copiado?"rgba(34,197,94,0.1)":"rgba(6,182,212,0.08)",color:copiado?"#22c55e":"#06b6d4",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:6 }}>
                <LuCopy /> {copiado ? "Copiado!" : "Copiar Pix"}
              </button>
              <button type="button" onClick={compartilhar} style={{ padding:"10px 8px",borderRadius:10,border:"1px solid rgba(118,87,255,.38)",background:"rgba(118,87,255,.08)",color:"#a99aff",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:6 }}>
                <LuShare2 /> Compartilhar
              </button>
            </div>
            {shareError && <p role="status" style={{color:"#fbbf24",fontSize:11,margin:"8px 0 0"}}>Compartilhamento indisponível. Use “Copiar Pix”.</p>}
          </div>
        )}

        <p style={{color:"rgba(255,255,255,.38)",fontSize:11,lineHeight:1.5,margin:"0 2px 14px",textAlign:"center"}}>Por segurança, a Zuno não tenta abrir um banco específico. Copie ou compartilhe o Pix e escolha seu banco normalmente.</p>
        <button type="button" onClick={onFechar} style={{ width:"100%",padding:14,borderRadius:14,border:"1px solid rgba(255,255,255,0.1)",background:"rgba(255,255,255,0.05)",color:"rgba(255,255,255,0.7)",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"inherit" }}>Fechar</button>
      </div>
    </div>
  );
}
